import React,{useEffect, useState} from "react";
import './YoutubeMonetize.css'
import StandardServicesLogo from './../../../../images/standardservicesstar.png'
import YoutubeMonetize1 from './../../../../images/youtubemonetizeimg1.png'
import YoutubeMonetize2 from './../../../../images/youtubemonetizeimg2.png'
import Select from 'react-select'
import YoutubeMonetizeBanner2 from './../../../../images/ytmonetizebanner2.png'
import YotubeMonetizeBackIcon from './../../../../images/ytmonetizebackicon.png'
import YotubeMonetizeImg1 from './../../../../images/ytmonetizeimg1.png'
import YotubeMonetizeImg2 from './../../../../images/ytmonetizeimg2.png'
import YotubeMonetizeImg3 from './../../../../images/ytmonetizeimg3.png'
import YotubeMonetizeImg4 from './../../../../images/ytmonetizeimg4.png'
import YotubeMonetizeImg5 from './../../../../images/ytmonetizeimg5.png'
import YotubeMonetizeImg6 from './../../../../images/ytmonetizeimg6.png'
import YotubeMonetizePoint from './../../../../images/ytmonetizedrawerarrow.png'
import YotubeMonetizedots from './../../../../images/ytmonetizebanner2dots.png'
import YotubeMonetizedots2 from './../../../../images/ytmonetizebanner2dots2.png'
import YotubeMonetizebanner3dash from './../../../../images/ytmonetizebanner3dashhori.png'
import YotubeMonetizebanner3ver from './../../../../images/ytmonetizebanner3dasvert.png'
import YotubeMonetize000 from './../../../../images/ytmonetize000.png'
import YotubeMonetizebl000 from './../../../../images/ytmonetizebl000.png'
import YotubeMonetizebanner3gdash from './../../../../images/ytmonetizebanner3gdashhori.png'
import YotubeMonetizebanner4vdash from './../../../../images/ytmonetizebanner4vertline.png'
import YotubeMonetizebanner6vdash from './../../../../images/ytmonetizebanner6vert.png'
import YotubeMonetizebanner6hdash from './../../../../images/ytmonetizebanner6hori.png'
import { hover } from "@testing-library/user-event/dist/hover";
import {useLocation,useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';

function YoutubeMonetize({nav}) {
    const [formView,setFormView] = useState(false)
    const [formSubmit,setFormSubmit] = useState(false)
    const [name,setName] = useState("")
    const [email,setEmail] = useState("")
    const [company,setCompany] = useState("")
    const [region,setRegion] = useState("")
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    const regionOptions = [{value:'South East Asia', label:'South East Asia'},
                               {value:'East Asia', label:'East Asia'},
                               {value:'South Asia', label:'South Asia'},
                               {value:'China', label:'China'}]
    const [country,setCountry] = useState("")
    const [companyType,setCompanyType] = useState("")
    const companyOptions = [{value:'Sole proprietorship', label:'Sole proprietorship'},
                               {value:'C corporation', label:'C corporation'},
                               {value:'Partnership', label:'Partnership'},
                               {value:'Limited liability company (LLC)', label:'Limited liability company (LLC)'}]
    const [help,setHelp] = useState("")            
    const helpOptions = [{value:'Marketing', label:'Marketing'},
                               {value:'Distibution', label:'Distibution'},
                               {value:'Logistics', label:'Logistics'},
                               {value:'Analytics', label:'Analytics'}]   
    const [phone,setPhone] = useState("")  
    const [webUrl,setWebUrl] = useState("")  
    const [genre,setGenre] = useState("")  

    const genreOptions = [{ value: 'Alternative', label: 'Alternative' },
    { value: 'Audiobooks', label: 'Audiobooks' },
    { value: 'Blues', label: 'Blues' },
    { value:'Children’s Music',  label:'Children’s Music'  },
    { value: 'Classical', label: 'Classical' },
    { value: 'Comedy', label: 'Comedy' },
    { value: 'Country', label: 'Country' },
    { value: 'Dance', label: 'Dance' },
    { value: 'Electronic', label: 'Electronic' },
    { value: 'Folk', label: 'Folk' },
    { value: 'Hip hop/Rap', label: 'Hip hop/Rap' },
    { value: 'Holiday', label: 'Holiday' },
    { value: 'Inspirational', label: 'Inspirational' },
    { value: 'Jazz', label: 'Jazz' },
    { value: 'Latin', label: 'Latin' },
    { value: 'New Age', label: 'New Age' },
    { value: 'Opera', label: 'Opera' },
    { value: 'Pop', label: 'Pop' },
    { value: 'R&B/Soul', label: 'R&B/Soul' },
    { value: 'Reggae', label: 'Reggae' },
    { value: 'Rock', label: 'Rock' },
    { value: 'Spoken Word', label: 'Spoken Word' },
    { value: 'Soundtrack', label: 'Soundtrack' },
    { value: 'Vocal', label: 'Vocal' },
    { value: 'World', label: 'World' }]

    const colourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '35.18em',
        height: '3.5em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'0.5em',
        cursor:'pointer',
        "&:hover": {
            backgroundColor: "rgba(254,254,254,20%)"
          }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            cursor:'pointer',
            "&:hover": {
                backgroundColor: 'rgba(0,0,0,100%)'
              }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
        hover : styles =>({
            backgroundColor:'rgba(255,255,255,16%)',
        })
      };

    const [catalogTracks,setCatalogTracks] = useState("")  

    const catalogOptions = [{value:'1-5', label:'1-5'},
                            {value:'6-15', label:'6-15'},
                            {value:'16-30', label:'16-30'},
                            {value:'31-100', label:'31-100'}]  

    const [monthTracks,setMonthTracks] = useState("") 
    
    const monthOptions = [{value:'1-5', label:'1-5'},
                            {value:'6-15', label:'6-15'},
                            {value:'16-30', label:'16-30'},
                            {value:'31-100', label:'31-100'}]  

    const [bestArtist,setBestArtist] = useState("")

    const [findUs,setFindUs] = useState("")

    const findUsOptions = [{value:'Website', label:'Website'},
                            {value:'Social Media', label:'Social Media'},
                            {value:'Email', label:'Email'},
                            {value:'Referral', label:'Referral'}]  

    const [moreDetail,setMoreDetails] = useState("")

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

    const changeRegionHandler = value => {
        setRegion(value)
    }

    const changeCompanyHandler = value => {
        setCompanyType(value)
    }

    const changeHelpHandler = value => {
        setHelp(value)
    }

    const changecatalogHandler = value => {
        setCatalogTracks(value)
    }

    const changemonthtracksHandler = value => {
        setMonthTracks(value)
    }

    const changeGenreHandler = value => {
        setGenre(value)
    }

    const findUsHandler = value => {
        setFindUs(value)
    }

    useEffect(()=>{
        topFunction()
    },[])

    
    return (

           
        <div style={{display:'flex',flexDirection:'column'}}>
                {
                !formView && !formSubmit &&
                <div>
                                <div style={{ 
                                    backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/hbu0v0v94kprq5vvbl6c")`, 
                                    height:'31.75em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'cover',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}
                            
                                    >
                                    <img src={YotubeMonetizeBackIcon} className="HoverBtn" onClick={()=>{
                                         if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                                            navigate("/Dashboard/promoteyourself")
                                          }
                          
                                          if(decodeToken(cookies.get('token')).info.role==="label"){
                                            navigate("/dashboard/label/promoteartist")
                                          }
                                        
                                        }}/>
                                    <div className="MaximizeEarnings">Maximize Your<br/> YouTube Earnings</div>
                                    <div className="UgcAndRights">ugc and rights management</div>
                                    <div  style={{height:'0.45em',width:'1.58em',backgroundColor:'#E91353',marginTop:'1em',marginBottom:'1em'}}/>
                                    <div className="TurnYour">Turn your YouTube views into revenue with our seamless monetization service.</div>
                                    <div className="GetInTouchBtn" style={{paddingTop:'0.8em',paddingBottom:'0.8em'}} onClick={()=>setFormView(true)}>
                                        Get in Touch
                                        <div className="PostLoginBtnOverlay"/>
                                    </div>
                                    <div style={{ 
                                    backgroundImage:`url(${YoutubeMonetizeBanner2})`, 
                                    height:'12.73em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative',
                                    marginTop:'0em',
                                    overflow:'hidden'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}     
                                    >
                                        <div style={{position:'absolute',width:'0.8em',height:'1em',top:'0em',left:'0em',backgroundColor:'#4CFFBE',clipPath:'polygon(0 0, 100% 85%, 100% 100%, 0% 100%)'}}/>
                                        <div style={{position:'absolute',width:'0.8em',height:'100%',top:'1em',left:'0em',backgroundColor:'#4CFFBE'}}/>
                            </div>
                            </div>
                
                            <div  style={{ 
                                    backgroundColor:'#DFDFDE', 
                                    height:'21.56em',
                                    // height:'50px',
                                    width:'100%',
                                    backgroundSize:'cover',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}>
                                    <div style={{position:'absolute',width:'0.8em',height:'100%',top:'0em',left:'0em',backgroundColor:'#4CFFBE'}}/>
                                    <div className="TheMostPowerfulUGC">
                                    The Most Powerful UGC and Rights Management<br/> Service and Platform in the Industry.
                                    
                                    </div>
                                    <img src={YotubeMonetizedots2} style={{position:'absolute',top:'7.89em',width:'6.93em',height:'3.25em',left:'7.19em'}}/>
                
                                    <img src={YotubeMonetizedots} style={{position:'absolute',top:'7.89em',width:'65%',height:'5.76em'}}/>
                                    
                                    <div
                                    style={{
                                    backgroundColor:'#0F1923',
                                    position:'absolute',
                                    bottom:'-1em',
                                    right:'0em',
                                    width:'15.206em',
                                    height:'2.79em',
                                    clipPath:'polygon(13% 0, 100% 0, 100% 100%, 0% 100%)'
                                    }}
                                    />
                            </div>
                
                            <div  style={{ 
                                    backgroundColor:'#0F1923', 
                                    // height:'50px',
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative',
                                    paddingBottom:'4.6em'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}>
                                    <img src={YotubeMonetizebanner3ver} style={{position:'absolute',left:'5%'}}/>
                                    <div style={{position:'absolute',width:'0.8em',height:'15em',top:'0em',left:'0em',backgroundColor:'#4CFFBE'}}/>
                
                                    <div style={{display:'flex',flexDirection:'row',paddingTop:'5em',paddingBottom:'5em'}}>
                                        <div style={{display:'flex',flexDirection:'column',position:'relative'}}>
                                            
                                            <div className="TransformYourContent">Transform Your Content into Revenue Seamlessly</div>
                                            <img src={YotubeMonetizebanner3dash} style={{width:'18.09em',height:'0.27em',marginTop:'1.5em',marginBottom:'1.5em'}}/>
                                            <div  className="WithYOutubeMonetization">With YouTube Monetization Service, you can easily monetize your YouTube videos. Our platform identifies and claims unauthorized uses of your content, ensuring you get paid. We provide detailed analytics to track your performance and offer global reach to expand your audience. Focus on creating great content while we handles the monetization and rights management.</div>
                
                                            <div style={{display:'flex',flexDirection:'row',marginTop:'1.5em'}}>
                                                <div style={{width:'0.215em',height:'1.72em',backgroundColor:'#E91353',marginRight:'0.625em'}}/>
                                                <div style={{width:'1.24em',height:'1.72em',backgroundColor:'#E91353',marginRight:'0.625em'}}/>
                                            </div>
                                        </div>
                
                                        <img src={YotubeMonetizeImg1} style={{width:'33.54em',height:'33.75em',marginLeft:'0.95em'}}/>
                
                                    </div>
                
                                    <div style={{display:'flex',flexDirection:'row',width:'64.5em',marginTop:'2.5em',paddingBottom:'2em',marginBottom:'2em',position:'relative'}}>
                                        <img src={YotubeMonetize000} style={{marginRight:'3em'}}/>
                                        <div className="OurSolutions">Our Solutions</div>
                                        <img src={YotubeMonetizebanner3gdash} style={{position:'absolute',bottom:'0em'}}/>
                                    </div>
                
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                        <img src={YotubeMonetizeImg2} style={{marginRight:'3em'}}/>
                
                                        <div>
                                            <span className="DrawerTitle" ><span style={{color:'#4CFFBE'}}>\\</span> UGC and Rights Management</span>
                
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                                <img src={YotubeMonetizePoint} style={{width:'2.36em',height:'2.36em',marginRight:'-1em'}}/>
                                                <div className="DrawerContainer">
                                                The most powerful user-generated content and rights management service in the industry. We ensure that all your creative works are protected and monetized efficiently.
                                                <div style={{display:"flex",flexDirection:'row',position:'absolute',bottom:'0em',right:'0em'}}>
                                                        <div className="div" style={{width:'13.07em',height:'0.125em'}}/>
                                                        <div className="div" style={{width:'1.05em',height:'0.125em',marginLeft:'0.5em'}}/>
                                                </div>
                                                </div>
                
                                                
                                            </div>
                                        </div>
                                    </div>
                
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                        
                
                                        <div>
                                            <span className="DrawerTitle" ><span style={{color:'#4CFFBE'}}>\\</span> Content ID and Optimization</span>
                
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2em'}}>
                                                <img src={YotubeMonetizePoint} style={{width:'2.36em',height:'2.36em',marginRight:'-1em'}}/>
                                                <div className="DrawerContainer" style={{paddingRight:'3em',paddingTop:'0em',clipPath:'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)'}}>
                                                Deliver your music to an extensive range of platforms. Our global team actively monitors and optimizes your content to ensure all policies and settings are in place to claim and monetize your music.
                                                <div style={{display:"flex",flexDirection:'row',position:'absolute',bottom:'0em',left:'0em'}}>
                                                        <div className="div" style={{width:'1.05em',height:'0.125em',marginRight:'0.5em'}}/>
                                                        <div className="div" style={{width:'13.07em',height:'0.125em'}}/>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                
                                        <img src={YotubeMonetizeImg3} style={{marginLeft:'3em'}}/>
                                    </div>
                
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                        <img src={YotubeMonetizeImg4} style={{marginRight:'3em'}}/>
                
                                        <div>
                                            <span className="DrawerTitle" ><span style={{color:'#4CFFBE'}}>\\</span> Trends and Reporting</span>
                
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1em'}}>
                                                <img src={YotubeMonetizePoint} style={{width:'2.36em',height:'2.36em',marginRight:'-1em'}}/>
                                                <div className="DrawerContainer" styl={{paddingTop:'0em',paddingRight:'5em'}}>
                                                Unlock detailed analytics through our portal. Set up custom reports and make critical comparisons between different digital service providers, enabling deeper analysis and strategic decision-making.
                                                <div style={{display:"flex",flexDirection:'row',position:'absolute',bottom:'0em',right:'0em'}}>
                                                        <div className="div" style={{width:'13.07em',height:'0.125em'}}/>
                                                        <div className="div" style={{width:'1.05em',height:'0.125em',marginLeft:'0.5em'}}/>
                                                </div>
                                                </div>
                
                                                
                                            </div>
                                        </div>
                                    </div>
                
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                        
                
                                        <div>
                                            <span className="DrawerTitle" ><span style={{color:'#4CFFBE'}}>\\</span> Enhanced Services</span>
                
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'2em'}}>
                                                <img src={YotubeMonetizePoint} style={{width:'2.36em',height:'2.36em',marginRight:'-1em'}}/>
                                                <div className="DrawerContainer" style={{paddingRight:'3em',paddingTop:'0em',clipPath:'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)'}}>
                                                We offer enhanced UGC monetization and rights management services, empowering rights holders with industry-leading technology and support from our team of content experts.
                                                <div style={{display:"flex",flexDirection:'row',position:'absolute',bottom:'0em',left:'0em'}}>
                                                        <div className="div" style={{width:'1.05em',height:'0.125em',marginRight:'0.5em'}}/>
                                                        <div className="div" style={{width:'13.07em',height:'0.125em'}}/>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                
                                        <img src={YotubeMonetizeImg5} style={{marginLeft:'3em'}}/>
                                    </div>
                
                            </div>
                
                            <div  style={{ 
                                    backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gduqr3xqmkgpihbdvjbo")`, 
                                    backgroundColor:'rgba(255,255,255,60%)',
                                    height:'37.66em',
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative',
                                    backgroundRepeat:'no-repeat',
                                    backgroundSize:'cover'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}>
                                    <img src={YotubeMonetizebanner4vdash} style={{position:'absolute',left:'5%',height:'100%'}}/>
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'66em',marginTop:'5em',position:'relative',paddingBottom:'1em'}}>
                                        <img src={YotubeMonetizebl000} style={{width:'1em',height:'2em',marginRight:'2em'}}/>
                                        <div className="WhyAdrev">Why Us?</div>
                                        <div style={{width:'19em',height:'3px',backgroundColor:'#4CFFBE',position:'absolute',bottom:'0em'}}/>
                                    </div>
                                
                
                                    
                
                
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'4em',position:'relative'}}>
                                            <div style={{marginRight:'2.5em'}}>
                                                <div className="AdrevHeader">In-House Expertise and Technology</div>
                                                <div className="AdrevDesc">Our claims team utilizes proprietary audio detection technology to identify and claim additional uses of sound recordings, ensuring you never miss out on potential revenue.</div>
                                            </div>
                                            <div style={{marginRight:'2.5em'}}>
                                                <div className="AdrevHeader">Multi-Channel Network Management</div>
                                                <div className="AdrevDesc">We partner with clients to manage their YouTube channels, boosting viewership, enhancing content discovery, and increasing video earnings through our exclusive Music Multi-Channel Network.</div>
                                            </div>
                                            <div style={{marginRight:'2.5em'}}>
                                                <div className="AdrevHeader">Pioneering Claim Management and Licensing</div>
                                                <div className="AdrevDesc">Utilize our premium claim management tool to handle complex claims, issue microsync licenses, and programmatically release claims on licensed content, all supported by a team specialized in revenue optimization in the YouTube ecosystem.</div>
                                            </div>
                
                                        <div style={{display:'flex',flexDirection:'row',position:'absolute',top:'16em'}}>
                                            <div style={{width:'0.28em',height:'2.34em',backgroundColor:'#0F1923',marginRight:'0.625em'}}/>
                                            <div style={{width:'1.6em',height:'2.34em',backgroundColor:'#0F1923'}}/>
                                        </div>
                                    </div>
                
                                <div style={{width:'60%',height:'2.79em',backgroundColor:'#0F1923',bottom:'-1em',left:'0',position:'absolute',clipPath:' polygon(0 0, 95% 0, 100% 100%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)'}}/>
                
                                
                
                            </div>
                
                            <div  style={{ 
                                    backgroundColor:'#0F1923',
                                    height:'35.125em',
                                    width:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    position:'relative',
                                    backgroundRepeat:'no-repeat',
                                    backgroundSize:'cover'
                                    //  transform: `translate(0%, ${positionY}px)`
                                    // lineHeight:'0px',
                                    // margin:'0px',
                                    // padding:'0px',
                                    // flex:'1'
                                    }}>
                
                                    <img src={YotubeMonetizebanner6vdash} style={{position:'absolute',left:'5%',bottom:'0'}}/>
                                            
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'7.87em'}}>
                                        <img src={YotubeMonetizeImg6} style={{marginRight:'1.5em'}}/>
                                        <div style={{display:'flex',flexDirection:'column'}}>
                                            <div className="Readytoboost">
                                            Ready to Boost Your YouTube Revenue?
                                            </div>
                                            
                                            <img src={YotubeMonetizebanner6hdash} style={{marginTop:'1.5em',marginBottom:'1.5em'}}/>
                                            <div className="maximizeYoutubeEarnings">
                                            Maximize your YouTube earnings with us. Our expert team and advanced technology make monetization simple. Start optimizing your revenue today.
                                            </div>
                
                                            <div className="GetInTouchBtn" style={{paddingTop:'0.8em',paddingBottom:'0.8em'}} onClick={()=>{setFormView(true);topFunction()}}>
                                                Get in Touch
                                                <div className="PostLoginBtnOverlay"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }   
                {
                formView && !formSubmit &&
                <div style={{backgroundColor:'#0F1923',paddingBottom:'8em',position:'relative', display:'flex',flexDirection:'column',alignItems:'center'}}>
                     <img src={YotubeMonetizeBackIcon} className="HoverBtnInv"  onClick={()=>{setFormView(false);setName("");
                                                                                                                                        setEmail("");
                                                                                                                                        setCompany("");
                                                                                                                                        setRegion("");
                                                                                                                                        setCountry("");
                                                                                                                                        setCompanyType("");
                                                                                                                                        setHelp("");
                                                                                                                                        setPhone("");
                                                                                                                                        setWebUrl("");
                                                                                                                                        setGenre("");
                                                                                                                                        setCatalogTracks("");
                                                                                                                                        setMonthTracks("");
                                                                                                                                        setBestArtist("");
                                                                                                                                        setFindUs("");
                                                                                                                                        setMoreDetails("")}}/>
                    <div className="GetInTouch">
                    Get in touch for more information
                    </div>

                    <div className="PleaseFillForm">
                    Please fill in the form below and submit it to get in touch for more <br/> information.
                    </div>

                    <span className="ytMonetizeFormHeader">
                        Name <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <input
                      value={name}
                      onChange={e =>{setName(e.target.value);}} 
                      className='ytInputField'
                      type='text'
                      // style={{marginLeft:'4.8em'}}
                      />

                    <span className="ytMonetizeFormHeader">
                        Email <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <input
                      value={email}
                      onChange={e =>{setEmail(e.target.value);}} 
                      className='ytInputField'
                      type='email'
                      // style={{marginLeft:'4.8em'}}
                      />

<span className="ytMonetizeFormHeader">
                        Company <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <input
                      value={company}
                      onChange={e =>{setCompany(e.target.value);}} 
                      className='ytInputField'
                      type='text'
                      // style={{marginLeft:'4.8em'}}
                      />

<span className="ytMonetizeFormHeader">
                        Region <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={regionOptions} value={region} onChange={changeRegionHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

                    <span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
                        Country <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <input
                      value={country}
                      onChange={e =>{setCountry(e.target.value);}} 
                      className='ytInputField'
                      type='text'
                      // style={{marginLeft:'4.8em'}}
                      />

                <span className="ytMonetizeFormHeader">
                        Company Type <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={companyOptions} value={companyType} onChange={changeCompanyHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

<span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
                        How can we help? <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={helpOptions} value={help} onChange={changeHelpHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

                    <span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
                        Phone 
                    </span>

                    <input
                      value={phone}
                      onChange={e =>{setPhone(e.target.value);}} 
                      className='ytInputField'
                      type='number'
                      // style={{marginLeft:'4.8em'}}
                      />

                        <span className="ytMonetizeFormHeader">
                        Website Url
                    </span>

                    <input
                      value={webUrl}
                      onChange={e =>{setWebUrl(e.target.value);}} 
                      className='ytInputField'
                      type='url'
                      // style={{marginLeft:'4.8em'}}
                      />

<span className="ytMonetizeFormHeader">
Primary genre of music <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={genreOptions} value={genre} onChange={changeGenreHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

<span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
How many tracks are in your  catalog? <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={catalogOptions} value={catalogTracks} onChange={changecatalogHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

<span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
How many tracks do you release every month? <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={monthOptions} value={monthTracks} onChange={changemonthtracksHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

<span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
                        Who is your best known artist?
                    </span>

                    <input
                      value={bestArtist}
                      onChange={e =>{setBestArtist(e.target.value);}} 
                      className='ytInputField'
                      type='text'
                      // style={{marginLeft:'4.8em'}}
                      />

<span className="ytMonetizeFormHeader">
How did you find us? <span style={{color:'#E91353'}}>&nbsp;*</span>
                    </span>

                    <Select options={findUsOptions} value={findUs} onChange={findUsHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="Select"
                    styles={
                      colourStyles
                    }/>

<span className="ytMonetizeFormHeader" style={{marginTop:'1em'}}>
                       More details of how we can help
                    </span>

                    <textarea  rows="4" cols="50" className='InputFieldbktextarea' onChange={e =>{setMoreDetails(e.target.value);}}   >
                        {moreDetail}
                    </textarea>

                    {
                   (name.length===0 || email.length===0 || company.length===0 || region.length===0 || country.length===0 || region.length===0 || country.length===0 || companyType.length===0 || help.length===0 || genre.length===0 || catalogTracks.length===0 || monthTracks.length===0 || findUs.length===0) &&
                    <div className="GetInTouchBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto',textTransform:'none',paddingTop:'1em',paddingBottom:'1em'}}>
                     Send
                    </div>
                    }
                    {
                    name.length!==0 && email.length!==0 && company.length!==0 && region.length!==0 && country.length!==0 && region.length!==0 && country.length!==0 && companyType.length!==0 && help.length!==0 && genre.length!==0 && catalogTracks.length!==0 && monthTracks.length!==0 && findUs.length!==0 &&
                    <div className="GetInTouchBtn" style={{textTransform:'none',paddingTop:'1em',paddingBottom:'1em'}} onClick={()=>{setFormSubmit(true);
                                                                                                                                        setName("");
                                                                                                                                        setEmail("");
                                                                                                                                        setCompany("");
                                                                                                                                        setRegion("");
                                                                                                                                        setCountry("");
                                                                                                                                        setCompanyType("");
                                                                                                                                        setHelp("");
                                                                                                                                        setPhone("");
                                                                                                                                        setWebUrl("");
                                                                                                                                        setGenre("");
                                                                                                                                        setCatalogTracks("");
                                                                                                                                        setMonthTracks("");
                                                                                                                                        setBestArtist("");
                                                                                                                                        setFindUs("");
                                                                                                                                        setMoreDetails("")}}>
                    Send
                    <div className="PostLoginBtnOverlay"/>
                    </div>
                    }
                   

                </div>
                }
                {
                    formSubmit &&
                    <div style={{height:'100vh',display:'flex',flexDirection:'column',alignItems:'center',backgroundColor:'#0F1923'}}>
                        <div className="GetInTouch">
                        Thanks! We’ll Get in Touch Soon
                        </div>

                        <span className="PleaseFillForm" style={{marginTop:'5em'}}>
                        Your message has been sent.<br/>
                        For any queries, reach out to us at <span>support@n3rve.com</span>
                        </span>

                        <div className="GetInTouchBtn" style={{textTransform:'none',paddingTop:'1em',paddingBottom:'1em'}} onClick={()=>{setFormSubmit(false);setFormView(false)}}>
                                       Return to main
                                        <div className="PostLoginBtnOverlay"/>
                                    </div>
                    </div>
                }
                        
                
            </div>
                       
    );
}

export default YoutubeMonetize;